import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:989
* @route '/teacher/settings/notifications'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/teacher/settings/notifications',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:989
* @route '/teacher/settings/notifications'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:989
* @route '/teacher/settings/notifications'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

const notifications = {
    update: Object.assign(update, update),
}

export default notifications